import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

export const name = "step";

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.value = action.payload;
    },
    nextPage: (state) => {
      state.value++;
    },
    prevPage: (state) => {
      state.value--;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
    reset: (state) => {
      state.value = null;
    }
  },
});

export const { actions, reducer } = slice;

export const getStep = (state) => state.step.value;